import React, { useMemo } from 'react';
import ReactDom from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import cx from 'classnames';
import { formattedPathKey } from 'helpers/formattedPathKey';

import { get, SiteConfigManager, useApplicationState } from '@atlas/core';
import {
  availableAccountRoutes,
  availableClientProfileRoutes,
  CLIENT_PROFILE_COMPONENT_TYPES,
  clientProfileRoutes,
  COMPONENT_TYPES,
} from '@atlas/routing';
import { Icon, Label, ScrollableContainer } from '@atlas/ui';

import ClientProfileTabNavigation from 'components/ClientProfile/ClientProfileTabNavigation';
import ShortFooter from 'components/Footer/ShortFooter';

import ProfileRouter from './ProfileRouter';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const { PROFILE } = CLIENT_PROFILE_COMPONENT_TYPES;

const { profile } = clientProfileRoutes;

const Profile = () => {
  const { pathname } = useLocation();
  const { authenticated } = useApplicationState();

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const clientProfileTabs = get(SiteConfigManager.getComponentOptions(CLIENT_PROFILE), 'tabs');
  const profileOptions = clientProfileTabs.find(({ type }) => type === PROFILE);

  const { isExpandedOnMobile, tabs = [] } = profileOptions;

  const activeTabs = useMemo(() => tabs.filter(tab => tab.isActive), [tabs]);

  const className = cx('profile-tab-container', isExpandedOnMobile && 'disable-top-navigation');

  const goBackMessage = isExpandedOnMobile
    ? formattedPathKey(pathname, clientProfilePath)
    : availableClientProfileRoutes[PROFILE].name;

  if (!authenticated) return null;

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <Link className="back-to-container" to={clientProfilePath}>
        <Icon className="icon-back" name="back" />
        <Label className="title-text" message={goBackMessage} />
      </Link>
      <ClientProfileTabNavigation
        availableRoutes={availableAccountRoutes}
        clientProfilePath={clientProfilePath}
        isExpandedOnMobile={isExpandedOnMobile}
        tabPath={profile}
        tabs={activeTabs}
      />
      <ScrollableContainer className={className} id="content">
        <ProfileRouter tabs={activeTabs} />
        <ShortFooter />
      </ScrollableContainer>
    </div>,
    document.body,
  );
};

export default Profile;
